import { differenceInDays, intlFormatDistance } from 'date-fns';
import { FMT } from '../../../util/formatter-service';

export function getNewsTime(newsDate: Date, refDate: Date = new Date()) {
  const d = differenceInDays(refDate, new Date(newsDate));
  if (d < 7) {
    return intlFormatDistance(new Date(newsDate), refDate);
  }
  return FMT.format('date', new Date(newsDate));
}
